import { store_util, connectPearents } from "./Fire_Base_API";

// name space area
const timestamp = store_util.Timestamp;
const firestore_server = store_util.FieldValue;
/**
 * firestore API class for ivent
 *
 * @export
 * @class ivent_API
 */
export default class ivent_API {
  /**
   * called firestore get ivent wrapper
   *
   * @static
   * @param {String} uid
   * @returns ivent_list Promise(resolve)
   * @memberof ivent_API
   */
  static get_Ivent_List(uid) {
    return new Promise((resolve, reject) => {
      connectPearents(uid)
        .orderBy("createTime", "desc")
        .get()
        .then(function(ivent_list_snapsht) {
          resolve(ivent_list_snapsht.docs);
        })
        .catch(function() {
          reject(null);
        });
    });
  }

  /**
   * called firestore delete ivent wrapper
   *
   * @static
   * @param {String} ivent_name
   * @param {String} uid
   * @memberof ivent_API
   */
  static delete_Ivent(ivent_key, uid) {
    return new Promise((resolve, reject) => {
      connectPearents(uid)
        .doc(ivent_key)
        .delete()
        .then(function() {
          resolve();
        })
        .catch(function() {
          reject();
        });
    });
  }

  /**
   * called firestore post ivent wrapper
   *
   * @static
   * @param {String} ivent_name
   * @param {Date} ivent_date
   * @param {String} uid
   * @memberof ivent_API
   */
  static post_Ivent(ivent_name, ivent_date, uid) {
    return new Promise((resolve, reject) => {
      connectPearents(uid)
        .add({
          name: ivent_name,
          date: timestamp.fromDate(ivent_date),
          createTime: firestore_server.serverTimestamp(),
          updateTime: firestore_server.serverTimestamp()
        })
        .then(function() {
          resolve();
        })
        .catch(function() {
          reject();
        });
    });
  }

  /**
   * called firestore pacth ivent wrapper
   *
   * @static
   * @param {String} ivent_key
   * @param {String} ivent_name
   * @param {Date} ivent_date
   * @param {String} uid
   * @memberof ivent_API
   */
  static pacth_Ivent(ivent_key, ivent_name, ivent_date, uid) {
    return new Promise((resolve, reject) => {
      connectPearents(uid)
        .doc(ivent_key)
        .update({
          name: ivent_name,
          date: timestamp.fromDate(ivent_date),
          updateTime: firestore_server.serverTimestamp()
        })
        .then(function() {
          resolve();
        })
        .catch(function() {
          reject();
        });
    });
  }
}
